module.exports = __webpack_public_path__ + "video-btn-1-06661c2e.png";